// eslint-disable-next-line import/prefer-default-export
export const AMBIENT_ENV = process.env.VUE_APP_APP_ENVIRONMENT;
